import isProduction from './is-production';
import isUITest from './is-ui-test';

const settings = {
    ids: {
        production: 'bd66299f-c217-43cf-b2bb-25bb0d257325',
        staging: '6f8cf91c-abd0-4080-9a16-a84773fd3670'
    }
};

const Braze = {
    availableEnvConfig() {
        const isProd = isProduction();
        const userID = window.storage.getItem('userId');
        const baseUrl = 'sdk.fra-01.braze.eu';

        if (isUITest()) {
            return null;
        }

        if (isProd && userID) {
            return {
                id: settings.ids.production,
                baseUrl
            };
        }

        return {
            id: settings.ids.staging,
            baseUrl
        };
    },

    init(): void {
        const envConfig = this.availableEnvConfig();

        if (envConfig) {
            // initialize the SDK
            window.appboy.initialize(envConfig.id, {
                baseUrl: envConfig.baseUrl
            });
            window.appboy.changeUser(window.storage.getItem('userId'));

            this.inited = true;
        }
    },

    inited: false,

    // start (or continue) a session
    triggerSession(): void {
        if (this.inited) {
            console.info('br_s');
            window.appboy.openSession();
        }
    }

    // tracker: {
    //     addToCart(data) {
    //         const materials = Array.isArray(data) ? data : [data];
    //
    //         materials.forEach(item => {
    //             console.info(item.id)
    //             appboy.logCustomEvent('addToCart', {
    //                 id: item.id
    //             });
    //         });
    //     }
    // }
};

export default Braze;
